// @ts-nocheck
/* eslint-disable */
import { node } from "~/util/dom";
import Scene from "~/scene";
import { getIcon } from "./util/providers/poiagg";

Mapy.ListPoi.Item = class {
	constructor(data, owner) {
		this._data = data;
		this._owner = owner;
		this._marker = null;
		this._ss = [];
		this._options = owner.getOptions();
		this._dom = {
			container : node("li", { title: this._data.title })
		}

		this._build();
	}

	destroy() {
		if (this._owner.getLayer()) {
			this._dom.container.removeEventListener("click",this, false);
			this._dom.container.removeEventListener("mouseover",this, false);
			this._dom.container.removeEventListener("mouseout",this, false);

			if (!this._options.markerOnHover) {
				this._owner.getLayer().removeMarker(this._marker);

				Scene.removeListeners(this._ss);
			}
		}
	}

	getContainer() {
		return this._dom.container;
	}

	getMarker() {
		return this._marker;
	}

	getData() {
		return this._data;
	}

	handleEvent(e) {
		switch(e.type) {
			case "mouseover":
				this._hover(true);
			break;
			case "mouseout":
				this._hover();
			break;
			case "click":
				e.preventDefault();
				this._click();
			break;
		}
	}

	_build() {
		var text = node("div", { className: "text" });
		var iconImg = this._data.icon ? Mapy.CDN.setSize(this._data.icon, Mapy.CDN.SIZE_40_40) : "";

		if (iconImg) {
			var img = node("img", { src: iconImg, crossOrigin: "anonymous" });
			this._dom.container.appendChild(img);
		} else {
			var url = getIcon(this._data.typeId, { scale: 1.5 });
			var icon = node("span", { className: "icon" });
			this._dom.container.appendChild(icon);

			if (url) {
				icon.style.backgroundImage = "url(" + url + ")";
			}
		}

		text.appendChild(node("h4", { innerHTML: this._data.title }));
		this._dom.container.appendChild(text);

		this._dom.container.addEventListener("click",this, false);
		this._dom.container.addEventListener("mouseover",this, false);
		this._dom.container.addEventListener("mouseout",this, false);

		if (this._owner.getLayer()) {
			var coords = Scene.coordsFromWGS84(this._data.mark.lon,this._data.mark.lat);
			var options = this._owner.getOptions();
			var urlPoitype = getIcon(this._data.typeId);

			this._marker = Scene.createMarkerPOI(coords, null, {visual: iconImg || urlPoitype ? Scene.VISUAL.MARKER_POI.SMALL : Scene.VISUAL.MARKER_POI.UNIVERSAL, url: iconImg, urlPoitype: urlPoitype ? urlPoitype : null});

			if (!this._options.markerOnHover) {
				this._ss.push(Scene.addListener("marker-poi-enter", "_markerEnter", this, this._marker));
				this._ss.push(Scene.addListener("marker-poi-leave", "_markerLeave", this, this._marker));
				this._ss.push(Scene.addListener("marker-click", "_click", this, this._marker));

				this._marker.setPlainId(this._data.id);
				this._marker.setSource(this._data.source);
				this._owner.getLayer().addMarker("search", this._marker, this._data.source, this._data.id);
			}
		}
	}

	_click() {
		if (!this._data.source || !this._data.id) { return; }
		this._hover();
		var state = {
			source: this._data.source,
			id: this._data.id,
			show: false
		}
		var detail = Mapy.getComponent("detail").setState(state).then(function() {
			Mapy.getComponent("history").save();
		}, () => {});
	}

	_hover(active) {
		this._dom.container.classList[active ? "add" : "remove"]("hover");
		if (this._owner.getLayer()) {
			if (this._options.markerOnHover) {
				if (active) {
					this._owner.getLayer().addMarker("search", this._marker, this._data.source, this._data.id);
				}
				else {
					this._owner.getLayer().removeMarker(this._marker);
				}
			}
			else {
				this._marker.setActive(active);
			}
		}
	}

	_markerEnter() {
		this._hover(true);
	}

	_markerLeave() {
		this._hover();
	}
};
